import { render } from "./UnitsList_unit_address.vue?vue&type=template&id=630f4dc4"
import script from "./UnitsList_unit_address.vue?vue&type=script&lang=js"
export * from "./UnitsList_unit_address.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__